/**
 * Rastro do veículo selecionado.
 *
 * **A linha é sempre a cor de movimento**, porque rota É movimento: o veículo
 * percorreu aquilo andando, qualquer que fosse o estado ao chegar. Quem carrega
 * o estado são as **marcas** — verde onde andava, azul onde estava parado com o
 * motor ligado, cinza onde desligou, vermelho sem comunicação.
 *
 * É o que transforma o rastro em relato: dá para ver o caminho e, sobre ele,
 * onde cada coisa aconteceu — sem abrir o histórico.
 *
 * Aparece só para o veículo selecionado: desenhar a frota inteira viraria
 * emaranhado e esconderia justamente o que se quer olhar.
 */
import { CircleMarker, Polyline, Tooltip } from "react-leaflet";
import { STATUS } from "../lib/fleet.ts";
import { formatTime } from "../lib/format.ts";
import type { TrailPoint } from "../lib/trail.ts";

export function VehicleTrail({ trail }: { trail: readonly TrailPoint[] }) {
  // Um ponto só não é rastro — é a posição atual, que o marcador já mostra.
  if (trail.length < 2) return null;

  return (
    <>
      {/* Uma linha só: a cor não varia mais, então não há motivo para quebrar
          em trechos — menos camadas no mapa e menos trabalho a cada quadro. */}
      <Polyline
        positions={trail.map((point) => [point.lat, point.lon] as [number, number])}
        // Cor CHEIA, sem transparência: sobre satélite ou mapa claro, um traço
        // a 75% se mistura com o fundo. E o traço interrompido separa o rastro
        // das vias da base — isso é forma, não transparência.
        pathOptions={{
          color: STATUS.moving.color,
          weight: 6,
          opacity: 1,
          dashArray: "6 6",
          lineCap: "round",
        }}
      />

      {/* O último ponto é onde o veículo está: o marcador já o desenha, e
          repetir aqui poria uma bolinha por cima dele. */}
      {trail.slice(0, -1).map((point, index) => (
          <CircleMarker
            key={`${point.lat},${point.lon},${point.at ?? index}`}
            center={[point.lat, point.lon]}
            radius={6}
            // Cor cheia também aqui: ponto meio transparente sobre satélite
            // vira mancha, e o estado — que é o que ele informa — se perde.
            pathOptions={{
              color: STATUS[point.status].color,
              weight: 1,
              opacity: 1,
              fillColor: STATUS[point.status].color,
              fillOpacity: 1,
            }}
          >
            <Tooltip direction="top" offset={[0, -4]} opacity={1}>
              <span className="text-[11px]">
                {formatTime(point.at)} — {STATUS[point.status].label}
              </span>
            </Tooltip>
          </CircleMarker>
      ))}
    </>
  );
}
